import React from "react";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { SearchFragmentPosts } from "@radarly/models/search";

function formatSortUnit(
  sort: SearchFragmentPosts["request"]["pagination"]["sort"]["on"]
) {
  const getUnit = sort.split(".");
  return getUnit.includes("radar") ? getUnit[1] : getUnit[0];
}

export default function SharedCardsSubtitlePostsSort({
  fragment,
}: {
  fragment: SearchFragmentPosts;
}) {
  const locale = useCurrentUserLocale();
  const sortUnit = formatSortUnit(fragment.request.pagination.sort.on);
  return <>{tr(locale, `TOP_POSTS::ORDER_BY_${sortUnit}`)}</>;
}
